import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class Fedora extends PositionedGoodyHOC {
	// 2
	render() {
		const style = {
			st47: {
				fill: '#444444',
			},
			st54: {
				fill: '#808080',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="39.1575317" cy="47.7731552" />
				<path style={style.st47} d="M40.2656517,50.7564507c-15.8204556,0-29.3717995-2.6666298-36.0864105-6.7271271
					c-2.4493117-1.2127914-4.017849-3.4524994-4.017849-6.4638138c0-4.1708298,3.0401332-7.8347397,7.8097916-7.8347397l0,0
					c0,0,6.3096633-17.7507153,10.2349129-23.8530083c2.3589287-3.6672506,6.4903202-5.7968574,10.8473339-5.6244926
					C33.2893753,0.4208441,38.3382988,2.985486,40.5,2.985486s7.2106247-2.564642,11.4465675-2.7322173
					c4.3570137-0.1723649,8.4884071,1.957242,10.847332,5.6244926c3.9252548,6.1022935,10.2349167,23.8530083,10.2349167,23.8530083
					l0,0c4.7696533,0,7.8097916,3.6639099,7.8097916,7.8347397c0,3.0113144-1.5685425,5.2510223-4.0178528,6.4638138
					c-6.7146072,4.0604973-20.2659531,6.7271271-36.0864067,6.7271271H40.2656517z" />
				<path style={style.st54} d="M11.6994762,19.8847885c-1.5018187,3.1969509-3.728291,9.8459816-4.0485196,9.8459816
					c5.7428441,3.7853127,18.21702,6.4092865,32.6890755,6.4092865c14.4719086,0,26.9459419-2.6239738,32.6887856-6.4092865
					c0,0-2.4208603-7.134943-3.9225311-10.3318939c-6.4930305,2.9264259-16.3816223,4.8520279-28.7662544,4.8520279
					S18.192358,22.8112144,11.6994762,19.8847885z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/Fedora.js